/*
 * <sidebar-drawer> – the filter sidebar (snippets/collection-filters.liquid) as an off-canvas drawer
 * on smaller screens. Opened by .button-sidebar-drawer-open (in the re-rendered collection/search
 * actions, hence delegated), closed by .js-button-sidebar-drawer-dismiss, Escape or a click outside.
 * Uses trapFocus/removeTrapFocus from assets/scripts.js.
 */
if (!customElements.get("sidebar-drawer")) {
  customElements.define(
    "sidebar-drawer",
    class SidebarDrawer extends HTMLElement {
      connectedCallback() {
        this.onKeyup = (event) => {
          if (event.code?.toUpperCase() === "ESCAPE") this.close();
        };
        this.addEventListener("keyup", this.onKeyup);
      }

      disconnectedCallback() {
        this.removeEventListener("keyup", this.onKeyup);
        if (this.isOpen) this.close();
      }

      get isOpen() {
        return document.body.classList.contains("page-layout-sidebar-drawer-open");
      }

      open(opener) {
        this.opener = opener;
        document.body.classList.add("page-layout-sidebar-drawer-open", "overflow-hidden-tablet");
        trapFocus(this, this.querySelector(".page-layout-sidebar-drawer-header"));
      }

      close() {
        document.body.classList.remove("page-layout-sidebar-drawer-open", "overflow-hidden-tablet");
        // The opener may have been replaced by a filter re-render; fall back to the current one
        const opener = this.opener?.isConnected
          ? this.opener
          : document.querySelector(".button-sidebar-drawer-open");
        removeTrapFocus(opener);
      }
    }
  );

  document.body.addEventListener("click", (event) => {
    const drawer = document.querySelector("sidebar-drawer");
    if (!drawer) return;
    const { target } = event;

    if (target.closest(".js-button-sidebar-drawer-dismiss")) {
      drawer.close();
      return;
    }
    const opener = target.closest(".button-sidebar-drawer-open");
    if (opener) {
      drawer.open(opener);
      return;
    }
    if (drawer.isOpen && !target.closest("sidebar-drawer")) {
      drawer.close();
      event.preventDefault();
    }
  });
}
